import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StatisticsBar } from '../../common/components/statistics-bar.component';
import { Theme } from '../../theme/theme';
import { FiltersBar } from '../../common/components/filters-bar.component';
import { DataTable } from '../../common/components/data-table.component';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { ActionMenu } from '../../common/components/action-menu.component';
import { FontAwesome } from '../../common/components/font-awesome';
import { CreateEditVideoForm } from './create-edit-video-form.container';
import { FloatingActionButton } from 'material-ui';
import { YesNoModal } from '../../common/components/yes-no-modal.component';
import { ProfileAvatar } from '../../common/components/profile-avatar.component';
import moment from 'moment';
import { AnalyticsView } from '../../analytics/components/analytics.component';

const styles = {
  addButton: {
    float: 'right'
  },
  actionIcon: {
    cursor: 'pointer',
    fontSize: 12,
    marginRight: 10
  },
  table: {
    marginLeft: '3%',
    marginRight: '3%'
  }
};

export class VideosView extends Component {
  static propTypes = {
    editModalOpen: PropTypes.bool,
    editModeEntity: PropTypes.any,
    statisticsData: PropTypes.any,
    toggleEditMode: PropTypes.func,
    removeVideo: PropTypes.func,
    skip: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    search: PropTypes.string.isRequired,
    yocasType: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    videos: PropTypes.shape({
      error: PropTypes.any,
      loading: PropTypes.bool,
      allVideos: PropTypes.shape({
        total: PropTypes.number,
        totalForFilter: PropTypes.number,
        items: PropTypes.arrayOf(PropTypes.any)
      })
    })
  };

  constructor() {
    super();

    this.state = {
      videoToRemove: null,
      videoToManage: null,
      allItems: [],
      startTime: moment().subtract(7, 'days').startOf('day'),
      endTime: moment().endOf('day'),
    };
  }

  componentDidMount() {
    console.log('Video component mounted');
    console.log('Initial statisticsData:', this.props.statisticsData);
    console.log('Initial statisticsData type:', typeof this.props.statisticsData);
    console.log('Initial statisticsData keys:', this.props.statisticsData ? Object.keys(this.props.statisticsData) : 'null');
    console.log('Client prop:', this.props.client);
    console.log('Videos prop:', this.props.videos);
    console.log('State startTime:', this.state.startTime);
    console.log('State endTime:', this.state.endTime);
  }

  handleDateChange = (startTime, endTime) => {
    this.setState({ startTime, endTime }, () => {
      // Refetch statistics with new date range
      if (this.props.data && this.props.data.refetch) {
        this.props.data.refetch({
          startTime: startTime.utc().format(),
          endTime: endTime.utc().format(),
        });
      }
    });
  };

  getAnalyticsParams() {
    return [
      {
        category: 'Video', action: 'VideoSelect', identifier: null, name: 'Video Selections',
      },
      {
        category: 'Video', action: 'VideoStart', identifier: null, name: 'Video Starts',
      },
      {
        category: 'Video', action: 'VideoComplete', identifier: null, name: 'Video Completions',
      },
    ];
  }

  componentDidUpdate(prevProps) {
    if (prevProps.statisticsData !== this.props.statisticsData) {
      console.log('Videos statistics data updated:', this.props.statisticsData);
      console.log('Videos statistics data keys:', this.props.statisticsData ? Object.keys(this.props.statisticsData) : 'null');
    }
  }

  updatePagination(nextData) {
    if (nextData) {
      this.props.updateFilter({ skip: this.props.skip + this.props.limit });
    } else {
      let newSkip = this.props.skip - this.props.limit;

      if (newSkip < 0) {
        newSkip = 0;
      }

      this.props.updateFilter({ skip: newSkip });
    }
  }

  resetFilter() {
    this.props.updateFilter({ skip: 0, search: '', yocasType: '' });
  }

  updateSearch(newValue) {
    this.props.updateFilter({ skip: 0, search: newValue });
  }

  updateVideoTypeFilter(event, index, value) {
    this.props.updateFilter({ skip: 0, yocasType: value });
  }

  getTitle() {
    if (this.props.editModeEntity) {
      if (Object.keys(this.props.editModeEntity).length === 0) {
        return 'Create Video';
      }

      if (this.isDisableEditForm(this.props.editModeEntity)) {
        return 'View Video';
      }

      return 'Edit Video';
    }

    return '';
  }

  isDisableEditForm(entity = this.props.editModeEntity) {
    return entity && entity.isVideo === false;
  }

  removeVideo(video) {
    this.setState({
      videoToRemove: video
    });
  }

  removeModalResult(doRemove) {
    console.log(doRemove, 'doRemove');
    const video = this.state.videoToRemove;

    this.setState({
      videoToRemove: null
    });

    if (doRemove) {
      this.props.removeVideo(video.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.videoToManage !== null &&
      nextProps.videos &&
      nextProps.videos.allvideos &&
      nextProps.videos.allvideos.items
    ) {
      this.setState({
        videoToManage: nextProps.videos.allvideos.items.find(
          video => video.id === this.state.videoToManage.id
        )
      });
      this.setState({
        allItems: this.props.videos.allVideos.items
      });
    }
  }

  getVideoStatistics() {
    const { statisticsData } = this.props;
    console.log('getVideoStatistics called with:', statisticsData);
    console.log('getVideoStatistics statisticsData type:', typeof statisticsData);
    console.log('getVideoStatistics statisticsData keys:', statisticsData ? Object.keys(statisticsData) : 'null');
    
    const result = [
      {
        name: 'Total Videos',
        value: statisticsData?.totalVideos || 0,
        color: Theme.PRIMARY_COLOR
      },
      {
        name: 'Sessions',
        value: statisticsData?.sessionVideos || 0,
        color: Theme.ACTIVE1_COLOR
      },
      {
        name: 'Poses',
        value: statisticsData?.poseVideos || 0,
        color: Theme.ACTIVE2_COLOR
      },
      {
        name: 'Modifications',
        value: statisticsData?.modificationVideos || 0,
        color: Theme.SECONDARY_COLOR
      }
    ];
    console.log('getVideoStatistics returning:', result);
    return result;
  }

  getVideoAnalyticsStatistics() {
    const { statisticsData } = this.props;
    console.log('getVideoAnalyticsStatistics called with:', statisticsData);
    const result = [
      {
        name: 'Total Views',
        value: statisticsData?.totalVideoViews || 0,
        color: Theme.PRIMARY_COLOR
      },
      {
        name: 'Completed',
        value: statisticsData?.completedVideoViews || 0,
        color: Theme.ACTIVE1_COLOR
      },
      {
        name: 'Completion Rate',
        value: statisticsData?.totalVideoViews > 0 
          ? Math.round((statisticsData.completedVideoViews / statisticsData.totalVideoViews) * 100)
          : 0,
        color: Theme.ACTIVE2_COLOR
      }
    ];
    console.log('getVideoAnalyticsStatistics returning:', result);
    return result;
  }

  getVideoTypeStatistics() {
    const { statisticsData } = this.props;
    console.log('getVideoTypeStatistics called with:', statisticsData);
    
    const result = [
      {
        name: 'Session Views',
        value: statisticsData?.sessionVideoViews || 0,
        color: Theme.PRIMARY_COLOR
      },
      {
        name: 'Session Completions',
        value: statisticsData?.sessionVideoCompletions || 0,
        color: Theme.ACTIVE1_COLOR
      },
      {
        name: 'Session Rate',
        value: statisticsData?.sessionVideoCompletionRate || 0,
        color: Theme.ACTIVE2_COLOR
      },
      {
        name: 'Pose Views',
        value: statisticsData?.poseVideoViews || 0,
        color: Theme.SECONDARY_COLOR
      },
      {
        name: 'Pose Completions',
        value: statisticsData?.poseVideoCompletions || 0,
        color: Theme.WARNING_COLOR
      },
      {
        name: 'Pose Rate',
        value: statisticsData?.poseVideoCompletionRate || 0,
        color: Theme.ERROR_COLOR
      },
      {
        name: 'Modification Views',
        value: statisticsData?.modificationVideoViews || 0,
        color: Theme.SUCCESS_COLOR
      },
      {
        name: 'Modification Completions',
        value: statisticsData?.modificationVideoCompletions || 0,
        color: Theme.INFO_COLOR
      },
      {
        name: 'Modification Rate',
        value: statisticsData?.modificationVideoCompletionRate || 0,
        color: Theme.DEFAULT_COLOR
      }
    ];
    
    console.log('getVideoTypeStatistics returning:', result);
    return result;
  }

  getVideoDurationStatistics() {
    const { statisticsData } = this.props;
    console.log('getVideoDurationStatistics called with:', statisticsData);
    
    const result = [
      {
        name: 'Short Views',
        value: statisticsData?.shortSessionViews || 0,
        color: Theme.PRIMARY_COLOR
      },
      {
        name: 'Short Completions',
        value: statisticsData?.shortSessionCompletions || 0,
        color: Theme.ACTIVE1_COLOR
      },
      {
        name: 'Short Rate',
        value: statisticsData?.shortSessionCompletionRate || 0,
        color: Theme.ACTIVE2_COLOR
      },
      {
        name: 'Medium Views',
        value: statisticsData?.mediumSessionViews || 0,
        color: Theme.SECONDARY_COLOR
      },
      {
        name: 'Medium Completions',
        value: statisticsData?.mediumSessionCompletions || 0,
        color: Theme.WARNING_COLOR
      },
      {
        name: 'Medium Rate',
        value: statisticsData?.mediumSessionCompletionRate || 0,
        color: Theme.ERROR_COLOR
      },
      {
        name: 'Long Views',
        value: statisticsData?.longSessionViews || 0,
        color: Theme.SUCCESS_COLOR
      },
      {
        name: 'Long Completions',
        value: statisticsData?.longSessionCompletions || 0,
        color: Theme.INFO_COLOR
      },
      {
        name: 'Long Rate',
        value: statisticsData?.longSessionCompletionRate || 0,
        color: Theme.DEFAULT_COLOR
      }
    ];
    
    console.log('getVideoDurationStatistics returning:', result);
    return result;
  }

  render() {
    const tableDesc = [
      { headerName: 'Name', width: 20, valueFrom: 'name' },
      { headerName: 'Label', width: 20, valueFrom: 'label' },
      { headerName: 'Type', width: 15, valueFrom: 'yocasType' },
      { headerName: 'Order', width: 15, valueFrom: 'order' },
      {
        headerName: 'File',
        width: 15,
        render: item => {
          if (item && item.data) {
            return (
              <div>
                <div
                  style={{
                    display: 'inline-block',
                    lineHeight: '30px',
                    verticalAlign: 'top',
                    marginLeft: 5
                  }}
                >
                  <FontAwesome
                    style={styles.actionIcon}
                    onClick={() => {
                      window.open(item.data);
                    }}
                    tooltip={'View File'}
                    name={'file'}
                  />
                </div>
              </div>
            );
          }

          return <span />;
        }
      },

      {
        headerName: 'Actions',
        width: 15,
        rowStyle: {
          overflow: 'visible'
        },
        render: item => {
          const disabled = this.isDisableEditForm(item);

          return (
            <div>
              <FontAwesome
                style={styles.actionIcon}
                onClick={() => this.props.toggleEditMode(item)}
                tooltip={disabled ? 'View' : 'Edit'}
                name={disabled ? 'eye' : 'pencil-square-o'}
              />
              {disabled ? null : (
                <FontAwesome
                  style={styles.actionIcon}
                  onClick={() => this.removeVideo(item)}
                  tooltip='Remove'
                  name='trash'
                />
              )}
            </div>
          );
        }
      }
    ];

    const totalForFilter = this.props.videos?.allVideos
      ? this.props.videos.allVideos.total
      : 0;
    const items = this.props.videos?.allVideos
      ? this.props.videos.allVideos.items
      : [];

    console.log('Render - videos prop:', this.props.videos);
    console.log('Render - totalForFilter:', totalForFilter);
    console.log('Render - items:', items);
    console.log('Render - statisticsData:', this.props.statisticsData);
    console.log('Render - statisticsData type:', typeof this.props.statisticsData);
    console.log('Render - statisticsData keys:', this.props.statisticsData ? Object.keys(this.props.statisticsData) : 'null');

    return (
      <div>
        <YesNoModal
          title='Are you sure?'
          open={this.state.videoToRemove !== null}
          onNo={() => this.removeModalResult(false)}
          onYes={() => this.removeModalResult(true)}
        >
          {this.state.videoToRemove === null ? null : (
            <div>
              Removing the video{' '}
              <strong>
                {this.state.videoToRemove.fullName}(
                {this.state.videoToRemove.identifier})
              </strong>{' '}
              will also remove the video from all participants that connected to
              it!
            </div>
          )}
        </YesNoModal>
        <ActionMenu
          onRequestClose={() => this.props.toggleEditMode(null)}
          title={this.getTitle()}
          open={this.props.editModalOpen}
        >
          <CreateEditVideoForm
            disabled={this.isDisableEditForm()}
            video={this.props.editModeEntity}
          />
        </ActionMenu>

        {this.props.statisticsData && (
          <>
            <StatisticsBar key={`video-stats-${this.props.statisticsData?.totalVideos || 0}`} data={this.getVideoStatistics()} />
            <StatisticsBar key={`video-analytics-${this.props.statisticsData?.totalVideoViews || 0}`} data={this.getVideoAnalyticsStatistics()} />
            <StatisticsBar key={`video-type-${this.props.statisticsData?.sessionVideos || 0}`} data={this.getVideoTypeStatistics()} />
            <StatisticsBar key={`video-duration-${this.props.statisticsData?.shortSessionVideos || 0}`} data={this.getVideoDurationStatistics()} />
          </>
        )}
        
        {!this.props.statisticsData && (
          <div style={{ padding: 20, textAlign: 'center', color: '#666' }}>
            Loading video statistics...
          </div>
        )}

        {this.props.client && (
          <AnalyticsView 
            params={this.getAnalyticsParams()} 
            client={this.props.client}
            startTime={this.state.startTime}
            endTime={this.state.endTime}
            onDateChange={this.handleDateChange}
          />
        )}

        <FiltersBar title='Videos'>
          <TextField
            hintText='Search Video'
            value={this.props.search}
            onChange={(event, newValue) => this.updateSearch(newValue)}
          />
          <SelectField
            floatingLabelText="Video Type"
            value={this.props.yocasType || ''}
            onChange={this.updateVideoTypeFilter.bind(this)}
            style={{ marginLeft: 20, width: 200 }}
          >
            <MenuItem value="" primaryText="All Types" />
            <MenuItem value="session" primaryText="Sessions" />
            <MenuItem value="Pose" primaryText="Poses" />
            <MenuItem value="modification" primaryText="Modifications" />
          </SelectField>
          <FloatingActionButton
            style={styles.addButton}
            onClick={() => this.props.toggleEditMode({})}
          >
            <FontAwesome name='plus' />
          </FloatingActionButton>
        </FiltersBar>
        <DataTable
          loading={this.props.videos?.loading || false}
          skip={this.props.skip || 0}
          limit={this.props.limit || 10}
          total={totalForFilter}
          onNext={() => this.updatePagination(true)}
          onPrev={() => this.updatePagination(false)}
          onResetFilter={() => this.resetFilter()}
          style={styles.table}
          idField='id'
          data={items}
          description={tableDesc}
        />
        <div id='someDiv'></div>
      </div>
    );
  }
}
